import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.USER_API}${path}`;

const UserService = {
  /**
   * Get logged in user info using /info endpoint.
   * @param {Number} [userId] - Optional userId to fetch instead of the logged in user
   * @returns {Promise<Object>} The logged in user.
   */
  getInfo(userId) {
    const querystring = userId ? `?id=${userId}` : '';
    return fetch(getUrl(`/info${querystring}`));
  },

  /**
   * Get plan of signed-in user. This is used to check if user
   * is on a free plan, or not.
   */
  getPlan() {
    return fetch(getUrl(`/plan/check`));
  },

  /**
   * Get list of team owners for the provided user.
   * @param {Number} userId - ID of the logged in user.
   * @returns {Promise<Object>} Team owner map
   */
  getUserAccounts(userId) {
    return fetch(getUrl(`/account/owners/${userId}`));
  },

  /**
   * Check if the provided owner has the given permissions.
   * @param {Number} owner - Account owner ID
   * @param {Array<String>} permissions - List of permissions to check
   * @returns {Promise<Object>} Map of permissions and whether or not the user has them.
   */
  getPermissions(owner, permissions) {
    return fetch(getUrl(`/plan/permissions/check?permissions=${permissions.join(',')}&owner=${owner}`));
  },
};

export default UserService;
